var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pending"},_vm._l((_vm.tasks),function(task){return _c('com-task',{key:task.id,attrs:{"task":task}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }